import { Theme, themes } from 'containers/Sidebar/themes';
import { useSidebarStatus } from 'containers/Sidebar/useSidebarStatus';
import tw from 'twin.macro';
import { ToggleChevron } from 'containers/Sidebar/components/ToggleChevron';
import React from 'react';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';

interface Props {
  theme?: Theme;
  children?: any;
}

export function SidebarWrapper({ theme = 'dark', children }: Props) {
  const { isOpen, close } = useSidebarStatus();
  const isMobile = useIsBelowBreakpoint('lg');

  return (
    <>
      {isMobile && isOpen && (
        <div
          tw="fixed inset-0 bg-black bg-opacity-50 z-[25] lg:hidden"
          onClick={close}
          aria-hidden="true"
        />
      )}
      <div
        css={[
          tw`relative transform transition-all ease-in-out duration-150 z-30 lg:z-20`,
          isOpen && tw`lg:w-60`,
          !isOpen && tw`lg:w-16`,
        ]}
      >
        <ToggleChevron theme={theme} />
        <div
          css={[
            tw`absolute left-0 top-0 lg:static lg:left-auto lg:top-auto transform h-screen lg:translate-x-0 overflow-y-auto shrink-0 py-4 transition-transform duration-200 ease-in-out overflow-x-hidden`,
            themes[theme].background,
            !isOpen && tw`px-2 -translate-x-64`,
            isOpen && tw`px-4 translate-x-0 w-[17rem] lg:w-auto`,
          ]}
        >
          {children}
        </div>
      </div>
    </>
  );
}
